// Shared team/roster sorting used by the Account edit form and the public team detail page.
// Four independent toggles (gender, age, grade, year), each Off / Asc / Desc.
// Active toggles combine left-to-right in the fixed order: gender, age, grade, year.

export const SORT_FIELDS = [
    ["gender", "Gender"],
    ["age", "Age"],
    ["grade", "Grade"],
    ["year", "Year"],
];

export const SORT_MODES = [
    ["off", "Off"],
    ["asc", "Asc"],
    ["desc", "Desc"],
];

// Default: every field ascending → Boys first, then age, then grade, then grad-year.
export const DEFAULT_SORT_STATE = { gender: "asc", age: "asc", grade: "asc", year: "asc" };

const numOf = (s) => {
    const m = String(s || "").match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
};

const fieldVal = (r, field) => {
    if (field === "gender") return r.gender === "F" ? 1 : 0;
    if (field === "age") return r.age_group ? numOf(r.age_group) : null;
    if (field === "grade") return r.grade ? numOf(r.grade) : null;
    if (field === "year") return r.grad_year ? numOf(r.grad_year) : null;
    return null;
};

export function sortRosters(list, sortState = DEFAULT_SORT_STATE) {
    const arr = [...(list || [])];
    const active = ["gender", "age", "grade", "year"].filter((f) => sortState[f] && sortState[f] !== "off");
    if (!active.length) return arr;
    arr.sort((a, b) => {
        for (const f of active) {
            const dir = sortState[f] === "desc" ? -1 : 1;
            const va = fieldVal(a, f);
            const vb = fieldVal(b, f);
            if (va == null && vb == null) continue;
            if (va == null) return 1; // teams missing this field sort last
            if (vb == null) return -1;
            if (va !== vb) return (va - vb) * dir;
        }
        return 0;
    });
    return arr;
}

export const rosterLabel = (r) => {
    const g = r.gender === "F" ? "Girls" : "Boys";
    const id = r.age_group || r.grade || r.grad_year || "";
    return `${g} ${id}`.trim();
};

export const hasCoach = (r) => !!((r && r.coach ? r.coach : "").trim());
export const teamIdentifier = (r) => r.age_group || r.grade || r.grad_year || "";

// Program roster order for the public team page: gender group first (Boys or Girls,
// per boysFirst), then ALWAYS highest → lowest age/grade/grad-year within each gender.
const ageRank = (r) => numOf(r.age_group) ?? numOf(r.grade) ?? numOf(r.grad_year);
export function sortProgramRosters(list, boysFirst = true) {
    const arr = [...(list || [])];
    arr.sort((a, b) => {
        const ga = a.gender === "F" ? 1 : 0;
        const gb = b.gender === "F" ? 1 : 0;
        if (ga !== gb) return boysFirst ? ga - gb : gb - ga;
        const va = ageRank(a);
        const vb = ageRank(b);
        if (va == null && vb == null) return 0;
        if (va == null) return 1;
        if (vb == null) return -1;
        return vb - va;  // highest first
    });
    return arr;
}
